// users_reset_password.jsx
import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Form, Input, Button, message } from 'antd';
import axios from 'axios';

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const version = "0.2.2 - 24/04/2025";

    const token = searchParams.get('token');
    const userId = searchParams.get('id');

    const handleResetPassword = async (values) => {
        try {
            setIsLoading(true);
            const response = await axios.post(`${baseURL}/users-reset-password`, {
                token,
                userId,
                newPassword: values.password
            });

            //console.log("handleResetPassword response.data step1: ", response.data);


            if (response.data.success) {
                message.success('Password reset successfully');
                navigate('/login');
            } else {
                message.error(response.data.message);
            }
        } catch (error) {
            //console.log("handleResetPassword error.response step2: ", error.response);
            // Check if the error has a response with data and message
            if (error.response && error.response.data && error.response.data.message) {
                message.error(error.response.data.message);
            } else {
                message.error('Failed to reset password');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="container-fluid">
            <div className="row">
                {/* Left Navigation Bar (copied from MainLayout) */}
                <div className="col-auto col-md-0 col-xl-0 px-sm-0 px-0" style={{ width: '224px', position: 'fixed', height: '100%', overflowY: 'auto' }}>
                    <div className="d-flex flex-column align-items-center align-items-sm-start px-2 pt-2 text-black min-vh-100 menu-vert-bar app_font1">

                        <div className="text-center py-0 d-flex flex-column align-items-center" style={{ width: '100%', color: 'white', bgcolor: '#527898' }}>
                            <a href="https://www.tracefabrics.com/" target="_blank" rel="noopener noreferrer">
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/app_logo2.png`}
                                    alt="Second Logo"
                                    style={{ width: '180px', marginTop: '10px', marginBottom: '10px' }}
                                />
                            </a>
                        </div>

                        {/* Wrap the image and version divs in a container */}
                        <div className="mt-auto w-100">
                            <div className="text-center w-100 py-2">
                                <a target="_blank" href="https://www.impetus.pt" rel="noopener noreferrer">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/logo_impetus.svg`}
                                        alt="Impetus Logo"
                                        style={{ width: '100px', marginBottom: '10px' }}
                                    />
                                </a>
                            </div>
                            <div className="text-center w-100 py-2" style={{ color: '#D0D4DB' }}>
                                <small>version {version}</small>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main Content Area */}
                <div className="col ml-4">
                    <div className="col p-0 m-0">
                        <div style={{ marginLeft: '220px', paddingTop: '20px' }}>
                            <div className="p-3 bg-white" style={{ maxWidth: '500px' }}>
                                <h2>Reset Password</h2>
                                <Form form={form} onFinish={handleResetPassword}>
                                    <Form.Item
                                        name="password"
                                        label="New Password"
                                        rules={[
                                            { required: true, message: 'Please input your new password!' },
                                            {
                                                //pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/,
                                                pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+[\]{};:'",.<>/?\\|~`])[A-Za-z\d!@#$%^&*()\-_=+[\]{};:'",.<>/?\\|~`]{8,}$/,
                                                message: 'Password must be at least 8 characters with uppercase, lowercase, number, and special character'
                                            }
                                        ]}
                                    >
                                        <Input.Password />
                                    </Form.Item>
                                    <Form.Item
                                        name="confirm"
                                        label="Confirm Password"
                                        dependencies={['password']}
                                        rules={[
                                            { required: true, message: 'Please confirm your password!' },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value || getFieldValue('password') === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(new Error('Passwords do not match!'));
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input.Password />
                                    </Form.Item>
                                    <Form.Item>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            loading={isLoading}
                                            style={{ backgroundColor: '#009a80', borderColor: '#009a80' }}
                                        >
                                            Reset Password
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;